export default "__VITE_ASSET__fe81e179__"